import {Deserializable} from './deserializable.model';

export class MyobServiceInvoice implements Deserializable {
// Myob Service Invoice Model
public UID?: string;
public Number?: string;
public Date?: Date;
public CustomerPurchaseOrderNumber?: string;
public Customer?: Customer;
public PromisedDate?: any;
public BalanceDueAmount?: number;
public BalanceDueAmountForeign?: any;
public Status?: string;
public Lines?: Line[];
public ShipToAddress?: string;
public Terms?: Terms;
public IsTaxInclusive?: boolean;
public Subtotal?: number;
public SubtotalForeign?: any;
public Freight?: number;
public FreightForeign?: any;
public FreightTaxCode?: FreightTaxCode;
public TotalTax?: number;
public TotalTaxForeign?: any;
public TotalAmount?: number;
public TotalAmountForeign?: any;
public Category?: Category;
public Salesperson?: Salesperson;
public Comment?: string;
public ShippingMethod?: string;
public JournalMemo?: string;
public ReferralSource?: string;
public InvoiceDeliveryStatus?: string;
public LastPaymentDate?: any;
public CanApplySurcharge?: boolean;
public Order?: Order;
public OnlinePaymentMethod?: string;
public ForeignCurrency?: any;
public CurrencyExchangeRate?: any;
public LastModified?: Date;
public URI?: string;
public RowVersion?: string;


 
  deserialize(input: any): this {
    // Assign input to our object BEFORE deserialize our cars to prevent already deserialized cars from being overwritten.
    Object.assign(this, input);

    // Iterate over all cars for our user and map them to a proper `Car` model
    //  this.cars = input.cars.map(car => new Car().deserialize(car));

       // Iterate over all addresses for our myob_conntact and map them to a proper `Address` model
    // this.Addresses = input.Addresses.map(address => new Address().deserialize(address));

    return this;
  }
  
//   getFullName() {
//     return this.FirstName + ' ' + this.LastName;
//   }



}



    export interface Customer {
        UID: string;
        Name: string;
        DisplayID: string;
        URI: string;
    }

    export interface Account {
        UID: string;
        Name: string;
        DisplayID: string;
        URI: string;
    }

    export interface TaxCode {
        UID: string;
        Code: string;
        URI: string;
    }

    export interface Line {
        RowID: number;
        Type: string;
        Description: string;
        RowVersion: string;
        UnitOfMeasure?: any;
        UnitCount?: any;
        UnitPrice?: any;
        UnitPriceForeign?: any;
        DiscountPercent?: number;
        Total?: number;
        TotalForeign?: any;
        Account: Account;
        Job?: any;
        TaxCode: TaxCode;
    }

    export interface Terms {
        PaymentIsDue: string;
        DiscountDate: number;
        BalanceDueDate: number;
        DiscountForEarlyPayment: number;
        MonthlyChargeForLatePayment: number;
        DiscountExpiryDate: Date;
        Discount: number;
        DiscountForeign?: any;
        DueDate: Date;
        FinanceCharge: number;
        FinanceChargeForeign?: any;
    }

    export interface FreightTaxCode {
        UID: string;
        Code: string;
        URI: string;
    }

    export interface Category {
        UID: string;
        Name: string;
        DisplayID: string;
        URI: string;
    }

    export interface Salesperson {
        UID: string;
        Name: string;
        DisplayID: string;
        URI: string;
    }

    export interface Order {
        UID: string;
        Number: string;
        URI: string;
    }




  /*
  * convert the JOSIN results of an API to any Model/Class/Interface Struction
  * @source: http://json2ts.com/
  */  